document.addEventListener('DOMContentLoaded', function () {
  // Early exit if gifting markup does not exist (e.g., Quick Shop)
  if (!document.getElementById('confirm-gifting')) {
    return
  }

  class GiftingDrawer extends HTMLElement {
    constructor() {
      super()
      this.clickedGiftButton = null

      this.setEventListeners()
    }

    setEventListeners() {
      const drawerOverlay = this.querySelector('#GiftingDrawer-Overlay')
      const giftDrawer = this.querySelector('#gifting-drawer')
      const giftTextarea = this.querySelector('#gift-message')
      const giftBoxPrice = document.querySelector('#gift-box-price')
      const selectedGiftBox = document.querySelector('#selected-gift-box')
      const closeGiftingBtn = this.querySelector('#close-gifting')
      if (closeGiftingBtn) {
        closeGiftingBtn.addEventListener('click', () => {
          this.closeDrawer()
        })
      } else {
        GiftUtils.log('close-gifting button not found')
      }

      document.addEventListener('click', event => {
        const giftButton = event.target.closest('.perfect-gift-btn')
        if (giftButton && !giftButton.disabled) {
          event.preventDefault()
          event.stopPropagation()
          this.clickedGiftButton = giftButton

          // Check if button is in cart drawer context
          // The button is in an addons-row, which is a sibling of the cart-item row
          const addonsRow = giftButton.closest('tr.cart-item__addons-row')
          let cartItemRow = null
          if (addonsRow) {
            // Find the previous sibling that is a cart-item (skip other addons rows)
            let prevSibling = addonsRow.previousElementSibling
            while (prevSibling && !prevSibling.classList.contains('cart-item')) {
              prevSibling = prevSibling.previousElementSibling
            }
            cartItemRow = prevSibling
          }
          // Fallback: try direct parent traversal
          if (!cartItemRow) {
            cartItemRow = giftButton.closest('tr.cart-item') || giftButton.closest('.cart-item')
          }

          if (cartItemRow) {
            this.setCartItemContextFromRow(cartItemRow)
            GiftUtils.log('Cart item context stored:', this.cartItemContext)
          } else {
            // Not in cart drawer, clear context
            this.cartItemContext = null
          }

          this.openDrawer()
        }
      })

      if (giftTextarea) {
        giftTextarea.addEventListener('input', event => {
          this.checkTextLength(event.target)
        })
      } else {
        GiftUtils.log('giftTextarea element not found - #gift-message element missing')
      }

      const giftBoxPriceSpan = document.getElementById('gift-box-price-tag')
      const giftDrawerMessage = document.getElementById('gift-message')

      if (drawerOverlay && giftDrawer) {
        drawerOverlay.addEventListener('click', () => {
          this.closeDrawer()
        })
      }

      // Product page: edit gifting options — re-open drawer
      const editGiftingBtn = document.getElementById('edit-gifting-options')
      if (editGiftingBtn) {
        editGiftingBtn.addEventListener('click', () => {
          this.cartItemContext = null
          this.openDrawer()
        })
      }

      // Product page: remove gifting options — reset state and hide confirmation
      const removeGiftingBtn = document.getElementById('remove-gifting-options')
      if (removeGiftingBtn) {
        removeGiftingBtn.addEventListener('click', () => {
          this.resetGiftBoxState()
          const selectedGiftingOptions = document.getElementById('selected-gifting-options')
          if (selectedGiftingOptions) {
            selectedGiftingOptions.style.display = 'none'
          }
        })
      }

      const confirmGiftingBtn = document.getElementById('confirm-gifting')

      if (confirmGiftingBtn) {
        confirmGiftingBtn.addEventListener('click', () => {
          const giftMessage = document.getElementById('gift-message')
          const giftBox = this.querySelector('.gift-box-checkbox:checked')
          const giftBoxData = {
            variantId: giftBox.value,
            productHandle: giftBox.dataset.productHandle,
            productTitle: giftBox.dataset.productTitle,
            productPrice: giftBox.dataset.productPrice,
            productPriceCents: giftBox.dataset.productPriceCents,
          }

          // These elements only exist on product pages, not in cart drawer context
          const selectedGiftMessage = document.getElementById(
            'selected-gift-message'
          )
          if (selectedGiftMessage) {
            selectedGiftMessage.value = giftMessage.value
          }

          // These elements only exist on product pages
          if (giftBox) {
            if (giftBoxPrice) giftBoxPrice.style.display = 'block'
            if (selectedGiftBox) selectedGiftBox.style.display = 'block'
          } else {
            if (giftBoxPrice) giftBoxPrice.style.display = 'none'
            if (selectedGiftBox) selectedGiftBox.style.display = 'none'
          }

          // Require gift box to be selected
          if (giftBox) {
            // This element only exists on product pages
            const selectedGiftingOptions = document.getElementById(
              'selected-gifting-options'
            )
            if (selectedGiftingOptions) {
              selectedGiftingOptions.style.display = 'block'
            }
            // If button was clicked from cart drawer, update the cart line item
            if (this.cartItemContext) {
              this.updateCartItemWithGiftMessage(
                this.cartItemContext,
                giftMessage.value,
                giftBoxData
              )
            } else {
              // Product page context - enable hidden inputs for form submission
              this.enableGiftInputs()
              // Ensure hidden inputs reflect the currently checked gift
              this.primeGiftDefaults()
            }

            this.closeDrawer()

            // Reset the clicked button reference
            this.clickedGiftButton = null
          } else {
            // No gift box selected - show error or warning
            GiftUtils.log('Cannot confirm: No gift box selected')
            const giftBoxesContainer = this.querySelector(
              '.gifting-drawer-checkboxes[data-dynamic-content="gift-boxes"]'
            )
            const existingCheckboxes =
              this.querySelectorAll('.gift-box-checkbox')

            if (existingCheckboxes.length === 0) {
              // Gift boxes haven't loaded yet - show message
              if (giftBoxesContainer) {
                const errorMsg = document.createElement('p')
                errorMsg.className = 'gifting-drawer-item-message'
                errorMsg.style.color = 'red'
                errorMsg.textContent =
                  'Please wait while gift boxes are loading...'
                giftBoxesContainer.appendChild(errorMsg)

                // Remove message after a delay
                setTimeout(() => {
                  if (errorMsg.parentNode) {
                    errorMsg.remove()
                  }
                }, 3000)
              }
            } else {
              // Gift boxes are loaded but none selected - show error
              alert('Please select a gift box option before confirming.')
            }
          }

          /**
           * Update the add to cart button with the updated price.
           * - Uses `setTimeout` to ensure that the other event listener in
           *   `gift-box-add-to-cart.js` has already fired.
           * - Future refactor could move the confirm gifting event listener and the
           *   code that disables/enables inputs into this file.
           */
          setTimeout(() => {
            this.updateAddToCartButton()
          }, 100)
        })
      } else {
        GiftUtils.log('confirm-gifting button not found')
      }

      this.setupCartGiftBoxEventListeners()
    }

    setupCartGiftBoxEventListeners() {
      document.addEventListener('click', event => {
        const editBtn = event.target.closest(
          '.cart-item__gift_box-edit-button-option'
        )
        if (editBtn) {
          event.preventDefault()
          // The edit button is in an addons-row, which is a sibling of the cart-item row
          const addonsRow = editBtn.closest('tr.cart-item__addons-row')
          let cartItemRow = null
          if (addonsRow) {
            // Find the previous sibling that is a cart-item (skip other addons rows)
            let prevSibling = addonsRow.previousElementSibling
            while (prevSibling && !prevSibling.classList.contains('cart-item')) {
              prevSibling = prevSibling.previousElementSibling
            }
            cartItemRow = prevSibling
          }
          // Fallback: try direct parent traversal
          if (!cartItemRow) {
            cartItemRow = editBtn.closest('tr.cart-item') || editBtn.closest('.cart-item')
          }
          if (cartItemRow) {
            this.setCartItemContextFromRow(cartItemRow)
          }
          this.openDrawer()
          return
        }

        const removeBtn = event.target.closest(
          '.cart-item__gift_box-remove-button-option'
        )
        if (removeBtn) {
          event.preventDefault()
          this.handleRemoveGiftBox(removeBtn)
          return
        }
      })
    }

    setCartItemContextFromRow(cartItemRow) {
      const itemKeyElement = cartItemRow.querySelector('[data-itemkeyid]')
      const itemKey = itemKeyElement?.getAttribute('data-itemkeyid')

      const rowIndex = cartItemRow.getAttribute('data-index')
      const rowId = cartItemRow.getAttribute('id')
      const itemLineOnCart = cartItemRow
        .querySelector('[data-itemlineoncart]')
        ?.getAttribute('data-itemlineoncart')

      let lineNumber = null
      if (itemLineOnCart) {
        lineNumber = parseInt(itemLineOnCart)
      } else if (rowIndex) {
        lineNumber = parseInt(rowIndex)
      } else if (rowId && rowId.includes('CartDrawer-Item-')) {
        lineNumber = parseInt(rowId.replace('CartDrawer-Item-', ''))
      }

      const productTitleElement = cartItemRow.querySelector('.cart-item__name')
      const productTitle = productTitleElement
        ? productTitleElement.textContent.trim()
        : null

      const productLink = cartItemRow.querySelector('.cart-item__link')
      let productHandle = null
      if (productLink && productLink.href) {
        const match = productLink.href.match(/\/products\/([^\/\?#]+)/)
        productHandle = match ? match[1] : null
      }
      const variantId =
        cartItemRow.getAttribute('data-product-id') ||
        cartItemRow
          .querySelector('[data-variant-id]')
          ?.getAttribute('data-variant-id')

      this.cartItemContext = {
        line: lineNumber,
        groupId: cartItemRow.getAttribute('data-group-id'),
        itemKey: itemKey,
        productTitle: productTitle,
        productHandle: productHandle,
        variantId: variantId,
      }
    }

    async handleRemoveGiftBox(removeBtn) {
      // The remove button is in an addons-row, which is a sibling of the cart-item row
      const addonsRow = removeBtn.closest('tr.cart-item__addons-row')
      let cartItemRow = null
      if (addonsRow) {
        // Find the previous sibling that is a cart-item (skip other addons rows)
        let prevSibling = addonsRow.previousElementSibling
        while (prevSibling && !prevSibling.classList.contains('cart-item')) {
          prevSibling = prevSibling.previousElementSibling
        }
        cartItemRow = prevSibling
      }
      // Fallback: try direct parent traversal
      if (!cartItemRow) {
        cartItemRow = removeBtn.closest('tr.cart-item') || removeBtn.closest('.cart-item')
      }
      GiftUtils.setCartLoading(true)

      try {
        const cart = await GiftUtils.fetchCart()

        const itemKeyElement = cartItemRow?.querySelector('[data-itemkeyid]')
        const itemKey = itemKeyElement?.getAttribute('data-itemkeyid')

        let cartItem = null
        let itemIndex = -1

        if (itemKey) {
          itemIndex = cart.items.findIndex(item => item.key === itemKey)
          if (itemIndex !== -1) {
            cartItem = cart.items[itemIndex]
          }
        }

        if (!cartItem) {
          GiftUtils.log('Could not find cart item to remove gift from')
          return
        }

        const groupId = cartItem.properties?._groupId
        const giftBoxItem = GiftUtils.findGiftBoxAddon(cart.items, groupId, cartItem.variant_id.toString())

        const updates = {}

        if (giftBoxItem) {
          updates[giftBoxItem.key] = 0
        }

        const existingProperties = { ...(cartItem.properties || {}) }
        delete existingProperties._hasGiftBox
        delete existingProperties._giftPid
        delete existingProperties._giftProductHandle
        delete existingProperties.Note

        await GiftUtils.cartPost('/cart/change.js', {
          line: itemIndex + 1,
          properties: existingProperties,
        })

        if (Object.keys(updates).length > 0) {
          await GiftUtils.cartPost('/cart/update.js', { updates })
        }

        GiftUtils.refreshCartUI()
      } catch (error) {
        console.error('[GiftBox Debug] Error removing gift box:', error)
      } finally {
        GiftUtils.setCartLoading(false)
      }
    }

    openDrawer() {
      const drawerOverlay = this.querySelector('#GiftingDrawer-Overlay')
      const giftDrawer = this.querySelector('#gifting-drawer')

      GiftUtils.setBodyOverflowHidden(true)
      giftDrawer.classList.add('open', 'animate')
      drawerOverlay.classList.add('active')

      const handle = this.getCurrentProductHandle()

      const giftBoxesContainer = this.querySelector(
        '.gifting-drawer-checkboxes[data-dynamic-content="gift-boxes"]'
      )

      if (!handle || !giftBoxesContainer) {
        GiftUtils.log('No product handle found for gift boxes')
        return
      }

      giftBoxesContainer.innerHTML =
        '<p class="gifting-drawer-item-message">Loading gift box options...</p>'

      this.populateGiftBoxesFromCart(handle)
        .then(() => this.primeGiftDefaults())
        .catch(err => console.error('[GiftBox Debug] Failed loading gift boxes:', err))
    }

    closeDrawer() {
      const drawerOverlay = this.querySelector('#GiftingDrawer-Overlay')
      const giftDrawer = this.querySelector('#gifting-drawer')
      const giftBoxesContainer = this.querySelector(
        '.gifting-drawer-checkboxes[data-dynamic-content="gift-boxes"]'
      )

      GiftUtils.setBodyOverflowHidden(false)
      giftDrawer.classList.remove('open')
      drawerOverlay.classList.remove('active')

      // Check if the drawer was closed without confirming (no gift box selected in UI)
      const selectedGiftingOptions = document.getElementById(
        'selected-gifting-options'
      )
      const isGiftConfirmed =
        selectedGiftingOptions &&
        selectedGiftingOptions.style.display !== 'none'

      if (!isGiftConfirmed) {
        // Reset gift box state when drawer is dismissed without confirming
        this.resetGiftBoxState()
      }

      if (giftBoxesContainer) {
        giftBoxesContainer.innerHTML = ''
      }
    }

    // check if drawer is open
    isDrawerOpen() {
      const drawer = this.querySelector('#gifting-drawer')
      return drawer?.classList.contains('open')
    }

    // Get the current product handle
    getCurrentProductHandle() {
      // Cart context
      if (this.cartItemContext?.productHandle) {
        return this.cartItemContext.productHandle
      }

      // References for PDP. References the buttons in buy-buttons.liquid
      const handleInput =
        document.querySelector('#gift-box-product-handle') ||
        document.querySelector('[data-product-handle]')

      if (handleInput?.value) return handleInput.value
      if (handleInput?.dataset?.productHandle)
        return handleInput.dataset.productHandle

      // Fallback
      const match = window.location.pathname.match(/\/products\/([^\/]+)/)
      return match ? match[1] : null
    }

    /**
     * Reset gift box state - uncheck checkboxes and disable/clear hidden inputs
     * This prevents gift boxes from being added when the drawer is dismissed without confirming
     */
    resetGiftBoxState({ forHotSwap = false } = {}) {
      // Uncheck all gift box radio buttons
      const giftBoxCheckboxes = this.querySelectorAll('.gift-box-checkbox')
      giftBoxCheckboxes.forEach(checkbox => {
        checkbox.checked = false
      })

      // Disable and clear all gift-related hidden inputs
      const giftInputs = document.querySelectorAll('.gifting-property')
      giftInputs.forEach(input => {
        input.disabled = true
        if (input.id !== 'hasgiftboxId' && input.id !== 'main__variantId') {
          // Clear values except for hasgiftboxId (which should stay 'true' but disabled)
          // and main__variantId (which is the main product ID)
          input.value = ''
        }
      })

      // Ensure hasgiftboxId is disabled (it should be, but double-check)
      const hasGiftBoxInput = document.getElementById('hasgiftboxId')
      if (hasGiftBoxInput) {
        hasGiftBoxInput.disabled = true
      }

      // Clear gift message textarea
      const giftMessage = document.getElementById('gift-message')
      if (giftMessage) {
        giftMessage.value = ''
        giftMessage.disabled = true
      }

      const textareaFeedback = this.querySelector('#textarea_feedback')
      if (textareaFeedback) {
        textareaFeedback.innerHTML = '0/100'
      }

      const giftBoxPrice = document.getElementById('gift-box-price')
      if (giftBoxPrice) {
        giftBoxPrice.dataset.priceCents = ''
      }

      if (forHotSwap) {
        // Clear dynamic gift box markup
        const container = this.querySelector(
          '.gifting-drawer-checkboxes[data-dynamic-content="gift-boxes"]'
        )
        if (container) {
          container.innerHTML =
            '<p class="gifting-drawer-item-message">Loading gift box options...</p>'
        }

        // Hide footer price display
        const priceTag = document.getElementById('gift-box-price-tag')
        if (priceTag) priceTag.style.display = 'none'

        // Clear visible selection summary (PDP safety)
        const selectedGiftBox = document.getElementById('selected-gift-box')
        if (selectedGiftBox) selectedGiftBox.innerHTML = ''

        const giftBoxPrice = document.getElementById('gift-box-price')
        if (giftBoxPrice) giftBoxPrice.style.display = 'none'
      }

      // Keep PDP CTA price in sync whenever gift state is reset/removed.
      this.updateAddToCartButton()
    }

    /**
     * Populate hidden inputs using the currently checked gift-box option.
     * Ensures properties like _giftProductHandle and ids are set even if user
     * didn't toggle the checkbox (default-checked).
     */
    primeGiftDefaults() {
      const checked = this.querySelector('.gift-box-checkbox:checked')
      if (!checked) return

      const giftBoxVariantIdField = document.querySelector(
        '#gift-box-variant-id'
      )
      const giftBoxGiftPid = document.querySelector('#gift__variantId')
      const giftBoxWithProduct = document.querySelector('#gift-box-for-product')
      const giftBoxProductHandle = document.querySelector(
        '#gift-box-product-handle'
      )
      const giftBoxProductHandleItem = document.querySelector(
        '#gift-box-product-handle-item'
      )
      const giftBoxPrice = document.querySelector('#gift-box-price')
      const selectedGiftBox = document.querySelector('#selected-gift-box')

      const mainTitleEl =
        document.querySelector('[data-product-title]') ||
        document.querySelector('.product__title')
      const mainTitle = mainTitleEl
        ? mainTitleEl.textContent.trim()
        : checked.dataset.parentProductTitle || document.title

      if (giftBoxVariantIdField) giftBoxVariantIdField.value = checked.value
      if (giftBoxGiftPid) giftBoxGiftPid.value = checked.value
      if (giftBoxWithProduct) giftBoxWithProduct.value = mainTitle
      if (giftBoxProductHandle)
        giftBoxProductHandle.value = checked.dataset.productHandle
      if (giftBoxProductHandleItem)
        giftBoxProductHandleItem.value = checked.dataset.productHandle
      if (giftBoxPrice) giftBoxPrice.innerHTML = checked.dataset.productPrice
      if (giftBoxPrice) {
        giftBoxPrice.dataset.priceCents = checked.dataset.productPriceCents || ''
      }
      if (selectedGiftBox)
        selectedGiftBox.innerHTML = checked.dataset.productTitle

      // Make sure these inputs submit
      this.enableGiftInputs()
    }

    /**
     * Fetch gift box handles from a product's metafield
     * @param {string} productHandle - The product handle to fetch gift boxes for
     * @returns {Promise<string[]>} Array of gift box product handles
     */
    async fetchGiftBoxHandles(productHandle) {
      GiftUtils.log('Fetching gift boxes for product:', productHandle)
      try {
        const pageRes = await fetch(`/products/${productHandle}`)
        if (!pageRes.ok) throw new Error('Failed to fetch product page')
        const pageHtml = await pageRes.text()

        const scriptHtml = GiftUtils.parseSectionHTML(pageHtml, '#product-gift-boxes-metafield')

        if (scriptHtml) {
          const data = JSON.parse(scriptHtml)
          if (data.metafields?.custom?.gift_boxes) {
            GiftUtils.log('Found gift boxes in fetched product page:', data.metafields.custom.gift_boxes)
            return data.metafields.custom.gift_boxes
          }
        }

        GiftUtils.log('No gift boxes metafield found in product page')
        return []
      } catch (error) {
        console.error('[GiftBox Debug] Error fetching gift box handles:', error)
        return []
      }
    }

    /**
     * Populate gift boxes dynamically when opened from cart drawer
     * Fetches gift boxes from the product's custom.gift_boxes metafield
     * @param {string} productHandle - The product handle to fetch gift boxes for
     */
    async populateGiftBoxesFromCart(productHandle) {
      const container = this.querySelector(
        '.gifting-drawer-checkboxes[data-dynamic-content="gift-boxes"]'
      )

      if (!container || !productHandle) return

      try {
        GiftUtils.log('Looking for gift boxes metafield for:', productHandle)

        // Look for metafield data in the specific script tag
        let giftBoxHandles = []
        const metafieldScript = document.getElementById(
          'product-gift-boxes-metafield'
        )

        if (metafieldScript) {
          // Product page context - read from current page DOM
          GiftUtils.log('Product page context - reading from current page')

          try {
            const data = JSON.parse(metafieldScript.textContent)
            if (data.metafields?.custom?.gift_boxes) {
              giftBoxHandles = data.metafields.custom.gift_boxes
              GiftUtils.log('Found gift boxes in metafield script')
            }
          } catch (e) {
            console.error('[GiftBox Debug] Failed to parse gift boxes metafield:', e)
          }
        } else {
          // Not on product page - need to fetch it (cart drawer or other context)
          GiftUtils.log('Not on product page - fetching product page')
          giftBoxHandles = await this.fetchGiftBoxHandles(productHandle)
        }

        if (
          !giftBoxHandles ||
          !Array.isArray(giftBoxHandles) ||
          giftBoxHandles.length === 0
        ) {
          GiftUtils.log('No gift boxes found in custom.gift_boxes metafield')
          container.innerHTML =
            '<p class="gifting-drawer-item-message">No gift box options available.</p>'
          return
        }

        GiftUtils.log('Found gift boxes in metafield:', giftBoxHandles)

        // Fetch each gift box product's details
        const giftBoxPromises = giftBoxHandles.map(async giftBoxHandle => {
          try {
            const giftBoxRes = await fetch(
              `/products/${giftBoxHandle.handle}.js`
            )
            if (!giftBoxRes.ok) {
              GiftUtils.log(`Failed to fetch gift box: ${giftBoxHandle.handle}`)
              return null
            }
            return await giftBoxRes.json()
          } catch (err) {
            console.error(`[GiftBox Debug] Error fetching gift box ${giftBoxHandle.handle}:`, err)
            return null
          }
        })

        const giftBoxProducts = (await Promise.all(giftBoxPromises)).filter(
          Boolean
        )

        if (!giftBoxProducts.length) {
          container.innerHTML =
            '<p class="gifting-drawer-item-message">No gift box options available.</p>'
          return
        }

        container.innerHTML = ''

        // Create radio buttons for each gift box product
        giftBoxProducts.forEach((giftBoxProduct, index) => {
          // Use the first available variant (typically the default variant)
          const variant =
            giftBoxProduct.variants.find(v => v.available) ||
            giftBoxProduct.variants[0]

          if (!variant) {
            GiftUtils.log(`No variant found for gift box: ${giftBoxProduct.handle}`)
            return
          }

          const id = `gift-box-${variant.id}`

          const wrapper = document.createElement('div')
          wrapper.className = 'gifting-drawer-checkbox'

          wrapper.innerHTML = `
            <input
              type="radio"
              name="gift-box"
              class="gift-box-checkbox"
              id="${id}"
              value="${variant.id}"
              data-product-title="${giftBoxProduct.title}"
              data-product-handle="${giftBoxProduct.handle}"
              data-product-price-cents="${variant.price}"
              data-product-price="${new Intl.NumberFormat(Shopify.locale, { style: 'currency', currency: Shopify.currency.active, currencyDisplay: 'narrowSymbol' }).format(variant.price / 100)}"
            />
            <label for="${id}">
              <span class="gifting-drawer-checkbox-title">${giftBoxProduct.title}</span>
              <span class="gifting-drawer-checkbox-price">
                ${new Intl.NumberFormat(Shopify.locale, { style: 'currency', currency: Shopify.currency.active, currencyDisplay: 'narrowSymbol' }).format(variant.price / 100)}
              </span>
            </label>
          `

          container.appendChild(wrapper)
        })

        this.attachGiftBoxListeners(container)

        // Auto-select first
        const first = container.querySelector('.gift-box-checkbox')
        if (first) {
          first.checked = true
          first.dispatchEvent(new Event('change', { bubbles: true }))
        }

        this.primeGiftDefaults()
      } catch (err) {
        console.error('[GiftBox Debug] Gift box JSON load failed:', err)
        container.innerHTML =
          '<p class="gifting-drawer-item-message">Error loading gift boxes.</p>'
      }
    }

    attachGiftBoxListeners(container) {
      const priceTag = document.getElementById('gift-box-price-tag')
      const message = document.getElementById('gift-message')

      container.querySelectorAll('.gift-box-checkbox').forEach(checkbox => {
        checkbox.addEventListener('click', () => {
          if (priceTag && checkbox.dataset.productPrice) {
            priceTag.textContent = `+${checkbox.dataset.productPrice}`
            priceTag.style.display = 'inline'
          }

          if (message) {
            message.disabled = false
            message.focus()
          }
        })

        checkbox.addEventListener('change', function () {
          if (message) message.disabled = !this.checked
        })
      })
    }

    updateAddToCartButton() {
      // This method only applies to product pages, not cart drawer context
      const hasGiftBoxInput = document.getElementById('hasgiftboxId')
      if (!hasGiftBoxInput) {
        return
      }

      const fallbackSection =
        document
          .querySelector('[id^="ProductSubmitButton-"]')
          ?.id?.replace('ProductSubmitButton-', '') || null
      const variantSelectSection =
        document.querySelector('variant-selects')?.dataset?.originalSection ||
        document.querySelector('variant-selects')?.dataset?.section ||
        null
      const section =
        this.dataset.originalSection ||
        this.dataset.section ||
        variantSelectSection ||
        fallbackSection
      if (!section) {
        // No section context (e.g., opened from cart drawer), skip update
        return
      }

      const variantSelects =
        document.querySelector(`variant-selects[data-original-section="${section}"]`) ||
        document.querySelector(`variant-selects[data-section="${section}"]`) ||
        document.querySelector('variant-selects')
      const addToCartButton = document.querySelector(
        `#ProductSubmitButton-${section}`
      )

      // Only update if add to cart button exists (product page context)
      if (!addToCartButton) {
        return
      }

      const isAddToCartDisabled = addToCartButton.hasAttribute('disabled')

      if (variantSelects) {
        variantSelects.toggleAddButton(isAddToCartDisabled, '')
      }
    }

    checkTextLength(element) {
      const giftCounter = this.querySelector('#textarea_feedback')
      const textMax = 100
      const format = /[^\u0000-\u007f]/
      const hasSpecialCharacters = format.test(element.value)

      if (hasSpecialCharacters) {
        element.value = element.value.replace(new RegExp(format, 'gi'), '')
      }

      const textLength = element.value.length

      if (textLength > textMax) {
        element.value = element.value.substring(0, textMax)
      } else {
        giftCounter.innerHTML = textLength + '/' + textMax
      }
    }

    /**
     * Ensure all gift-box related hidden inputs are enabled before the product
     * form is submitted. Disabled inputs are ignored when the browser builds
     * FormData, which was why the note and box title were missing on the first
     * add-to-cart.
     */
    enableGiftInputs() {
      const idsToEnable = [
        'gift-box-variant-id',
        'gift__variantId',
        'gift-box-for-product',
        'selected-gift-message',
        'hasgiftboxId',
        'main__variantId',
        'main-product-groupId',
        'gift-box-groupId',
        'gift-box-addon',
        'gift-box-addon-type',
      ]

      idsToEnable.forEach(id => {
        const el = document.getElementById(id)
        if (el) {
          el.disabled = false
        }
      })

      // Ensure gift box product handle inputs are enabled so they submit
      const handleInputs = [
        'gift-box-product-handle',
        'gift-box-product-handle-item',
      ]
      handleInputs.forEach(id => {
        const el = document.getElementById(id)
        if (el) {
          el.disabled = false
        }
      })
    }

    /**
     * Update cart line item with gift message when editing from cart drawer
     * @param {Object} cartItemContext - Context info about the cart item
     * @param {string} noteValue - The gift message note value
     */
    async updateCartItemWithGiftMessage(
      cartItemContext,
      noteValue,
      giftBoxData
    ) {
      // Get the cart item row element for UI updates
      const cartItemRow =
        this.clickedGiftButton?.closest('tr.cart-item') ||
        this.clickedGiftButton?.closest('.cart-item') ||
        document.querySelector(`#CartDrawer-Item-${cartItemContext.line}`) ||
        document.querySelector(
          `.cart-item[data-itemkeyid="${cartItemContext.itemKey}"]`
        )

      try {
        GiftUtils.setCartLoading(true)

        // First, get the current cart to find the line item
        const cart = await GiftUtils.fetchCart()

        // Find the cart item by key (most reliable) or line number
        let cartItem = null
        let lineNumber = null
        let itemIndex = -1

        // First try to find by item key (most reliable)
        if (cartItemContext.itemKey) {
          itemIndex = cart.items.findIndex(
            item => item.key === cartItemContext.itemKey
          )
          if (itemIndex !== -1) {
            cartItem = cart.items[itemIndex]
            // Line number is 1-based, so it's the array index + 1
            lineNumber = itemIndex + 1
          }
        }

        // If not found by key, try by line number
        if (!cartItem && cartItemContext.line) {
          lineNumber = parseInt(cartItemContext.line)
          // Line numbers are 1-based, array is 0-based
          if (lineNumber > 0 && lineNumber <= cart.items.length) {
            itemIndex = lineNumber - 1
            cartItem = cart.items[itemIndex]
            // Ensure lineNumber is correct (1-based)
            lineNumber = itemIndex + 1
          }
        }

        // Final validation - ensure we have both cartItem and lineNumber
        if (!cartItem) {
          GiftUtils.log('Could not find cart item to update', {
            cartItemContext,
            cartItems: cart.items.map((it, idx) => ({
              variant_id: it.variant_id,
              key: it.key,
              index: idx,
              calculatedLine: idx + 1,
            })),
          })
          return
        }

        // Ensure we have a valid line number (calculate from index if needed)
        if (!lineNumber || isNaN(lineNumber)) {
          if (itemIndex !== -1) {
            lineNumber = itemIndex + 1
          } else {
            // Fallback: find the index of the cart item
            itemIndex = cart.items.indexOf(cartItem)
            if (itemIndex !== -1) {
              lineNumber = itemIndex + 1
            }
          }
        }

        if (!lineNumber || isNaN(lineNumber)) {
          GiftUtils.log('No valid line number found for cart item', {
              cartItem: { key: cartItem.key, variant_id: cartItem.variant_id },
              cartItemContext,
              itemIndex,
              lineNumber,
              cartItemsCount: cart.items.length,
            }
          )
          return
        }

        // Ensure lineNumber is an integer
        lineNumber = parseInt(lineNumber)

        // Get gift box information from the passed parameter
        const giftBoxVariantId = giftBoxData.variantId
        const giftBoxProductHandle = giftBoxData.productHandle

        // Get existing properties
        const existingProperties = { ...(cartItem.properties || {}) }

        // Check if gift box already exists for this item
        const existingGroupId = existingProperties._groupId
        const existingGiftBoxItem = existingGroupId
          ? GiftUtils.findGiftBoxAddon(cart.items, existingGroupId, cartItem.variant_id.toString())
          : null

        // Only set Note when gift box is selected
        existingProperties.Note = noteValue || ''

        // Add gift box as an addon item
        // Generate or use existing groupId
        const groupId = existingGroupId || GiftUtils.generateGroupId()

        // Update main product properties
        existingProperties._hasGiftBox = 'true'
        existingProperties._giftPid = giftBoxVariantId
        existingProperties._giftProductHandle = giftBoxProductHandle
        existingProperties._groupId = groupId

        // Split or update main cart item with Note and gift box properties
        if (cartItem.quantity > 1) {
          // Split: reduce existing line by 1 (keep original without gift properties)
          const reducePayload = {
            line: lineNumber,
            quantity: cartItem.quantity - 1,
          }

          GiftUtils.log('Reducing existing line quantity:', reducePayload)
          const reduceResponse = await GiftUtils.cartPost('/cart/change.js', reducePayload)

          if (!reduceResponse.ok) {
            const errorText = await reduceResponse.text()
            console.error('[GiftBox Debug] Failed to reduce cart item quantity:', reduceResponse.status, errorText)
            return
          }

          // Add new line with qty 1 + gift properties
          const addPayload = {
            id: cartItem.variant_id,
            quantity: 1,
            properties: existingProperties,
          }
          const sellingPlanId = cartItem.selling_plan_allocation?.selling_plan?.id
          if (sellingPlanId) addPayload.selling_plan = sellingPlanId

          GiftUtils.log('Adding split gifted line:', addPayload)
          const addResponse = await GiftUtils.cartPost('/cart/add.js', addPayload)

          if (!addResponse.ok) {
            const errorText = await addResponse.text()
            console.error('[GiftBox Debug] Failed to add gifted line:', addResponse.status, errorText)
            return
          }
        } else {
          // qty == 1: update in-place (existing behavior)
          const updatePayload = {
            line: lineNumber,
            quantity: 1,
            properties: existingProperties,
          }

          const updateResponse = await GiftUtils.cartPost('/cart/change.js', updatePayload)

          if (!updateResponse.ok) {
            const errorText = await updateResponse.text()
            console.error('[GiftBox Debug] Failed to update cart item:', updateResponse.status, errorText)
            return
          }
        }

        // Add or update gift box as addon item
        if (existingGiftBoxItem) {
          // Gift box already exists - check if we need to update it
          const existingGiftBoxVariantId =
            existingGiftBoxItem.variant_id.toString()
          const giftBoxChanged = existingGiftBoxVariantId !== giftBoxVariantId

          if (giftBoxChanged) {
            // Remove old gift box and add new one
            const removeOldGiftBox = {
              line:
                existingGiftBoxItem.line ||
                cart.items.indexOf(existingGiftBoxItem) + 1,
              quantity: 0,
            }

            GiftUtils.log('Removing old gift box:', removeOldGiftBox)

            await GiftUtils.cartPost('/cart/change.js', removeOldGiftBox)

            // Add new gift box
            const addGiftBoxPayload = {
              id: parseInt(giftBoxVariantId),
              quantity: 1,
              properties: {
                _parentPid: cartItem.variant_id.toString(),
                _groupId: groupId,
                _addon: 'true',
                _addonType: 'Gift Box',
                _giftProductHandle: giftBoxProductHandle,
              },
            }

            GiftUtils.log('Adding new gift box addon:', addGiftBoxPayload)

            const addResponse = await GiftUtils.cartPost('/cart/add.js', addGiftBoxPayload)

            if (!addResponse.ok) {
              const errorText = await addResponse.text()
              console.error('[GiftBox Debug] Failed to add gift box:', addResponse.status, errorText)
              return
            }
          }
          // If gift box hasn't changed, no need to update it
        } else {
          // No existing gift box - add new one
          const addGiftBoxPayload = {
            id: parseInt(giftBoxVariantId),
            quantity: 1,
            properties: {
              _parentPid: cartItem.variant_id.toString(),
              _groupId: groupId,
              _addon: 'true',
              _addonType: 'Gift Box',
              _giftProductHandle: giftBoxProductHandle,
            },
          }

          GiftUtils.log('Adding gift box addon:', addGiftBoxPayload)

          const addResponse = await GiftUtils.cartPost('/cart/add.js', addGiftBoxPayload)

          if (!addResponse.ok) {
            const errorText = await addResponse.text()
            console.error('[GiftBox Debug] Failed to add gift box:', addResponse.status, errorText)
            return
          }
        }

        GiftUtils.refreshCartUI()
        if (window.updateCartItemCount) {
          await window.updateCartItemCount()
        }
      } catch (error) {
        console.error('[GiftBox Debug] Error updating cart item with gift message:', error)
      } finally {
        GiftUtils.setCartLoading(false)
      }
    }
  }

  // Only define the custom element if it hasn't been defined already
  if (!customElements.get('gifting-drawer')) {
    customElements.define('gifting-drawer', GiftingDrawer)
  }
})
